export default __webpack_public_path__ + "static/media/twitter-fill.26b9da38.svg";